import styled from 'styled-components/macro'
import { colors } from 'styles/colors'
import { screen } from 'styles/mq'

export const AboutContainer = styled.div`
  position: relative;
  top: 84px;
  left: -20px;
  width: calc(100% + 40px);
  height: calc(100% - 84px);
  z-index: 3;
  @media (max-width: ${screen.m}) {
    top: 84px;
    width: calc(100% + 16px);
    left: -8px;
    height: auto;
    z-index: 1;
  }
  @media (max-width: ${screen.xs}) {
    width: calc(100% + 24px);
    left: -12px;
    top: 64px;
  }
  > div {
    padding: 20px 0;
    padding: 20px;
    height: 100%;
    @media (max-width: ${screen.m}) {
      padding: 8px;
      height: auto;
    }
    @media (max-width: ${screen.xs}) {
      padding: 0px;
    }
  }
  ul li a {
    margin: 0;
  }

  ul.social_media,
  ul.contacts,
  .platforms,
  ul.satellite_data {
    position: relative;
    font-size: 21px;
    @media (max-width: ${screen.xxl}) {
      font-size: 18px;
    }
    @media (max-width: ${screen.xs}) {
      font-size: 14px;
    }
    h3 {
      font-size: 24px;
      font-weight: 300;
      @media (max-width: ${screen.xxl}) {
        font-size: 21px;
      }
    }
    li {
      padding: 4px 0;
    }
    li p {
      margin: 0;
    }
    li a {
      display: block;
      position: relative;
      margin: 0;
      padding: 0;
      text-decoration: none;
      font-size: 18px;
      line-height: 26px;
      @media (max-width: ${screen.xxl}) {
        font-size: 16px;
        line-height: 24px;
      }
      color: ${colors.black};
      &:hover {
        color: ${colors.plum};
      }
      svg {
        position: absolute;
        top: 3px;
        fill: ${colors.plum};
      }
      span {
        position: relative;
        display: inline-block;
        padding-left: 32px;
      }
    }
  }
`
